module.exports = "/React/dist/7bfdb66176e569767c8461aa40845a0e.jpg";